import { useState } from 'react';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

export const useAddComment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addComment = async ({ postId, comment }) => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('accessToken');
      const userId = localStorage.getItem('userId');
      if (!token || !userId) throw new Error('User not authenticated');
      const response = await apiClient.post(
        '/posts/comment',
        { postId, comment, status: 'approved' },
        {
          headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}`,
            'userId': userId,
          },
        }
      );
      if (!response.data?.success) {
        throw new Error(response.data?.message || 'Failed to add comment');
      }
      return response.data;
    } catch (err) {
      setError(err.message || 'Failed to add comment');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { addComment, loading, error };
}; 